import { render } from "./EventItemAttributeLineCross.vue?vue&type=template&id=2a6cca5a&ts=true"
import script from "./EventItemAttributeLineCross.vue?vue&type=script&lang=ts"
export * from "./EventItemAttributeLineCross.vue?vue&type=script&lang=ts"

import "./EventItemAttributeLineCross.vue?vue&type=style&index=0&id=2a6cca5a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__